import { ModuleFE_Value, ModuleFE_Variable } from '@app/hcs-frontend';
import { currentTimeMillis, Hour } from '@nu-art/ts-common';
const wbcVarId = '5c818bbaccf3ff8fe31e65b89b6475ba';
const generateNumericFindingTest = (results) => {
    const variable = ModuleFE_Variable.cache.unique(wbcVarId);
    const value = ModuleFE_Value.cache.unique(variable.valueId);
    const result = {
        variable,
        metadata: {
            varNormal: [0, 10],
            measurementUnitId: value?.data?.unitsId,
        },
        results: results.map((resultProps, index) => {
            const value = (Math.random() * 10) + (resultProps.abnormal ? 10 : 0);
            return {
                rawValue: value,
                currentEncounter: resultProps.currentEncounter,
                timestamp: currentTimeMillis() - (index * Hour),
            };
        })
    };
    return result;
};
export const FindingTooltipNumericTests = () => [
    {
        label: 'Single Normal Value',
        data: generateNumericFindingTest([{ currentEncounter: true }])
    },
    {
        label: 'Single Abnormal Value',
        data: generateNumericFindingTest([{ currentEncounter: true, abnormal: true }])
    },
    {
        label: 'Single Normal Value - Previous Encounter',
        data: generateNumericFindingTest([{ currentEncounter: false }])
    },
    {
        label: 'Single Abnormal Value- Previous Encounter',
        data: generateNumericFindingTest([{ currentEncounter: false, abnormal: true }])
    },
    {
        label: 'Multiple Values',
        data: generateNumericFindingTest([
            { currentEncounter: true },
            { currentEncounter: true },
            { currentEncounter: true }
        ]),
    },
    {
        label: 'Multiple Values W/ Abnormal values',
        data: generateNumericFindingTest([
            { currentEncounter: true },
            { currentEncounter: true, abnormal: true },
            { currentEncounter: true },
            { currentEncounter: true, abnormal: true },
        ]),
    },
    {
        label: 'Multiple Values W/ Previous Encounter',
        data: generateNumericFindingTest([
            { currentEncounter: true },
            { currentEncounter: true },
            { currentEncounter: false },
            { currentEncounter: false },
        ]),
    },
    {
        label: 'Mega Mix',
        data: generateNumericFindingTest([
            { currentEncounter: true },
            { currentEncounter: true },
            { currentEncounter: true, abnormal: true },
            { currentEncounter: false },
            { currentEncounter: false, abnormal: true },
        ]),
    },
];
//# sourceMappingURL=numeric.js.map